import { AiOutlineClose } from 'react-icons/ai';
import { ConferenceSchedule } from '../resources/data/itinerary-test-interfaces';
import Agenda from './Agenda';
import ItineraryHeader from './ItineraryHeader';

interface ItineraryPopUpProps {
  qrCodeURL: string;
  itinerary: ConferenceSchedule;
  onClick: () => void;
}

function ItineraryPopUp({
  qrCodeURL,
  itinerary,
  onClick,
}: ItineraryPopUpProps) {
  return (
    <div
      className={`ItineraryContainer flex w-full flex-col items-center gap-8 overflow-y-scroll bg-white`}
    >
      <div
        className=" absolute right-6 top-8  z-[51] hover:cursor-pointer"
        onClick={onClick}
      >
        <div className="RouteIcon relative flex h-8 w-8 items-center justify-center rounded-full bg-white bg-opacity-70 p-2">
          <AiOutlineClose size={24} />
        </div>
      </div>
      <ItineraryHeader qrCodeURL={qrCodeURL} />
      <Agenda itinerary={itinerary} />
    </div>
  );
}

export default ItineraryPopUp;
